import { render, staticRenderFns } from "./LayoutPlay.vue?vue&type=template&id=19a47d86&scoped=true"
import script from "./LayoutPlay.vue?vue&type=script&lang=js"
export * from "./LayoutPlay.vue?vue&type=script&lang=js"
import style0 from "./LayoutPlay.vue?vue&type=style&index=0&id=19a47d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a47d86",
  null
  
)

export default component.exports